// rm-audio-bar.js — playback transport bar with scrubber and time readout.
//
// STUB — Brief 001 may use it directly inside <rm-player>, or leave the
// inline buttons in place. Either way the contract is: takes `currentTimeSec`
// and `durationSec` props, emits `seek` events with `{ detail: timeSec }`.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class RMAudioBar extends RMComponent {
  static props = ["currentTimeSec", "durationSec"];
  /** @type {number} */ currentTimeSec = 0;
  /** @type {number} */ durationSec = 0;

  static styles = `
    :host { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0; }
    input[type=range] { flex: 1; }
    .time { color: var(--rm-muted); font-size: 0.8rem; min-width: 4rem; text-align: right; font-variant-numeric: tabular-nums; }
  `;

  render() {
    const t = Number(this.currentTimeSec) || 0;
    const d = Math.max(1, Number(this.durationSec) || 0);
    return html`
      <input type="range" min="0" max="${d}" step="0.1" value="${t}"
             on:input=${(e) => this.emit("seek", parseFloat(/** @type {HTMLInputElement} */ (e.target).value))}>
      <span class="time">${formatTime(t)} / ${formatTime(d)}</span>
    `;
  }
}

/** @param {number} sec */
function formatTime(sec) {
  if (!Number.isFinite(sec) || sec < 0) sec = 0;
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}
